import { render, staticRenderFns } from "./StockPurchaseOrderMovementsTable.vue?vue&type=template&id=905b5bc0&scoped=true"
import script from "./StockPurchaseOrderMovementsTable.vue?vue&type=script&lang=js"
export * from "./StockPurchaseOrderMovementsTable.vue?vue&type=script&lang=js"
import style0 from "./StockPurchaseOrderMovementsTable.vue?vue&type=style&index=0&id=905b5bc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905b5bc0",
  null
  
)

export default component.exports